import { loadModules, utils } from 'esri-loader';

class ArbExplorer {
  constructor() {
    this.mapServiceUrl =
      'http://map.arboretum.harvard.edu/arcgis/rest/services/CollectionExplorer/MapServer/';
    this.vectorLayerUrl =
    'https://www.arcgis.com/sharing/rest/content/items/7dc6cea0b1764a1f9af2e679f642f0f5/resources/styles/root.json';
    //  'https://www.arcgis.com/sharing/rest/content/items/1c13788bb9df46b492a56950b3ffeb46/resources/styles/root.json';

    //'https://www.arcgis.com/sharing/rest/content/items/e30be8b1434841338c9d5ea27e756495/resources/styles/root.json';
    // https://developers.arcgis.com/javascript/latest/api-reference/index.html
    this.mapOptions = { url: 'https://js.arcgis.com/4.15/' };
    // attributes available on plant: http://map.arboretum.harvard.edu/arcgis/rest/services/CollectionExplorer/MapServer/36
    this.plantFields = [
      'ACC_NUM_AND_QUAL',
      'ACC_DT',
      'RECD_HOW',
      'COUNTRY',
      'PSOURCE',
      'HEIGHT_NUM',
    ];
    this.plantLayerId = 15;
    this.results = [];
    this.livingPlants = [];
    this.displayedPlants = [];
    this.deadPlants = [];
    this.additionalPlants = document.querySelector('.js-remaining-specimen-count');
    this.tableRows = document.querySelector('.js-specimen-table').children;
    this.tableMaxRows = 5;
    this.statsContainer = null;
    this.stats = null;
    this.futureGreen = '#69e261';
    this.timelessGreen = '#344430';
    this.scientificName = document.querySelector('.js-arb-explorer-content').dataset.scientificName;
    this.collectionName = document.querySelector('.js-arb-explorer-content').dataset.collectionName;
    // this.expeditionName = document.querySelector('.js-arb-explorer-content').dataset.expeditionName;
    this.acquisitionsList = document.querySelector('.js-arb-explorer-content').dataset.acquisitionsList;
    // collection zone/Garden Location information provided by kport@oeb.harvard.edu
    this.collectionsMap = new Map([
      ['Azalea Border', [1.3]],
      ['Bonsai & Penjing', [1.19]],
      ['Bradley Rosaceous', [1.8, 1.9, (1.21).C]],
      ['Bussey Brook Meadow', [6.1, 6.2, (6.3).A, (6.3).B, (6.3).C, (6.3).D]],
      ['Conifer', [3.4, 3.6, 3.7, 3.8, 3.9]],
      ['Cosmopolitan', [7.1]],
      ['Crabapple', [4.13]],
      ['Explorers Garden', [2.11]],
      ['Hemlock Hill', [5.2, 5.3, 5.4, 5.5, (5.6).A, (5.6).B, (5.6).C]],
      ['Leventritt Shrub & Vine Garden', [1.13]],
      ['Lilac', [2.1]],
      ['Maple', [1.6]],
      ['Rhododendron Dell', [5.1]],
      ['Weld Hill', [7.1, 7.2, 7.3, 7.4]],
    ]);

    //  this.expeditionsMap = new Map([
    //    ['2018 Oregon Washington Expedition', ['2420*A', '16941*B', '16815*A']],
    //  ]);

    if (this.scientificName || this.collectionName || this.expeditionName || this.acquisitionsList) {
      this.getPlants();
      utils.Promise = window.Promise;
    } else {
      this.hideArbExplorer();
    }
  }

  hideArbExplorer() {
    this.hideElement(document.querySelector('.js-arb-explorer'));
    if (this.scientificName) {
      this.hideElement(this.statsContainer);
    }
    if (this.collectionName) {
      this.hide(document.querySelector('.topper__subtitle'));
    }
  }

  hideElement(element) {
    element.classList.add('visually-hidden');
  }

  // sql queries do not support × and single quotes need to be escaped
  // this will potentially need to be updated when graft chimeras with '+' in their names are added
  sqlFriendly(term) {
    return term.replace('×', 'x').replace(/'/g, '\'\'');
  }

  whereQuery() {
    if (this.scientificName) {
      this.scientificName = this.sqlFriendly(this.scientificName);
      return `SCIENTIFIC_NAME LIKE '${this.scientificName}' and CONDITION NOT IN ('Dead', 'Removed', 'Unable to locate')`;
    }
    if (this.collectionName) {
      const collectionIds = this.collectionsMap.get(this.collectionName).join('\',\'');
      return `GARDEN_COLLECTION IN ('${collectionIds}') and CONDITION NOT IN ('Dead', 'Removed', 'Unable to locate')`;
    }
    // if (this.expeditionName) {
    //   const expeditionIds = this.expeditionsMap.get(this.expeditionName).join('\',\'');
    //   return `ACC_NUM_AND_QUAL IN ('${expeditionIds}') and CONDITION NOT IN ('Dead', 'Removed', 'Unable to locate')`;
    // }
    if (this.acquisitionsList) {
      const acquisitionsIds = this.acquisitionsList.replace(/(\s*,\s*)/g, '\',\'');
      return `ACC_NUM_AND_QUAL IN ('${acquisitionsIds}') and CONDITION NOT IN ('Dead', 'Removed', 'Unable to locate')`;
    }
  }

  //  stats are set based on location in arbStats array defined in single-plant.php
  //  [living, dead, oldest, youngest, tallest]
  setStat(int, stat) {
    this.stats[int].querySelector('.stats__stat').innerHTML = stat;
  }

  getPlantStats() {
    this.stats = this.statsContainer.querySelector('.stats').children;
    this.livingPlants.forEach(plant => {
      plant.attributes['ACC_DT'] = plant.attributes['ACC_DT'].split('-')[2];
      if (!plant.attributes['HEIGHT_NUM']) {
        plant.attributes['HEIGHT_NUM'] = 0;
      } else {
        plant.attributes['HEIGHT_NUM'] = parseFloat(plant.attributes['HEIGHT_NUM']).toFixed(2);
      }
    });

    this.setStat(0, this.livingPlants.length);
    this.setStat(1, this.deadPlants.length);
    this.setStat(
      2,
      Math.min.apply(
        Math,
        this.livingPlants.map(function(o) {
          return o.attributes['ACC_DT'];
        }),
      ),
    );
    this.setStat(
      3,
      Math.max.apply(
        Math,
        this.livingPlants.map(function(o) {
          return o.attributes['ACC_DT'];
        }),
      ),
    );
    const tallestPlant = Math.max.apply(
      Math,
      this.livingPlants.map(function(o) {
        return o.attributes['HEIGHT_NUM'];
      }),
    );
    if (tallestPlant !== 0) {
      this.setStat(4, `${tallestPlant}m`);
    } else {
      this.hideElement(this.stats[4]);
    }
  }

  createAccessionLink(cell, value) {
    const accessionLink = document.createElement('a');
    // when updating this link, also update the link in accession-number.twig and modal-gallery/index.js
    accessionLink.setAttribute('href', `https://arboretum.harvard.edu/explorer/?id=${value}`);
    accessionLink.setAttribute('target', '_blank');
    const linkText = document.createTextNode(value);
    accessionLink.appendChild(linkText);
    cell.appendChild(accessionLink);
    // this gets added by tables.js when td has nested elements
    cell.querySelector('.cell-contents').remove();
  }

  cleanSource(value) {
    const cutIndex = value.indexOf('via');
    if (cutIndex >= 0) {
      return value.substring(0, cutIndex);
    } else {
      return value;
    }
  }

  buildTable(displayedPlants) {
    const resultCount = this.livingPlants.length;
    const rowCount = resultCount < this.tableMaxRows ? resultCount : this.tableMaxRows;
    const accessionRow = 0;
    const sourceRow = 4;
    for (let rowCounter = 0; rowCounter < this.tableMaxRows; rowCounter++) {
      if (rowCounter < rowCount) {
        const selector = this.livingPlants[rowCounter].attributes['ACC_NUM_AND_QUAL'].replace(
          '*',
          '_',
        );
        this.tableRows[rowCounter].classList.add(`js-plant-row-${selector}`);
        for (let colCounter = 0; colCounter < this.tableMaxRows; colCounter++) {
          const value = displayedPlants[rowCounter].attributes[this.plantFields[colCounter]];
          const cell = this.tableRows[rowCounter].children[colCounter];
          if (value) {
            if (colCounter === accessionRow) {
              this.createAccessionLink(cell, value);
            } else if (colCounter === sourceRow) {
              cell.innerHTML = this.cleanSource(value);
            } else {
              cell.innerHTML = value;
            }
          } else {
            cell.innerHTML = 'Unknown';
          }
        }
      } else {
        this.hideElement(this.tableRows[rowCounter]);
      }
    }
    if (resultCount > this.tableMaxRows) {
      this.additionalPlants.innerHTML = `${resultCount - this.tableMaxRows} more specimens`;
    }
  }

  // Query plants by scientific name using the arcgis API 4.15 https://developers.arcgis.com/javascript/latest/api-reference/index.html
  getPlants() {
    const sectionHeader = document.querySelector('.js-arb-explorer .section-header__title');
    if (this.scientificName) {
      this.statsContainer = document.querySelector('.js-stats');
    }

    // Used to load esri modules outside of a DOJO application https://github.com/Esri/esri-loader#why-is-this-needed
    loadModules(['esri/tasks/QueryTask', 'esri/tasks/support/Query'], this.mapOptions).then(
      ([QueryTask, Query]) => {
        const queryTask = new QueryTask({
          url: this.mapServiceUrl + this.plantLayerId,
        });

        const livingQuery = new Query({
          outFields: this.plantFields,
          where: this.whereQuery(),
          returnGeometry: true,
          outSpatialReference: {
            wkid: 102100,
          },
        });

        const deadQuery = new Query({
          where: `SCIENTIFIC_NAME LIKE '${this.scientificName}' and CONDITION IN ('Dead', 'Removed')`,
          outFields: this.plantFields,
        });

        queryTask
          .execute(livingQuery)
          .then(results => {
            this.results = results;
            this.livingPlants = results.features;
            sectionHeader.insertAdjacentHTML('afterbegin', `${this.livingPlants.length} `);
            if (this.livingPlants.length) {
              this.livingPlants.forEach((plant, i) => {
                plant.symbol = {
                  type: 'simple-marker',
                  color: i < this.tableMaxRows ? 'white' : this.timelessGreen,
                  size: 10,
                  outline: {
                    width: 1,
                    style: 'solid',
                    color: i < this.tableMaxRows ? this.timelessGreen : 'white',
                  },
                };
              });
              this.displayedPlants = this.livingPlants.slice(0, this.tableMaxRows);
              this.buildTable(this.displayedPlants);
              this.drawMap();
              if (this.scientificName) {
                if (this.livingPlants.length <= this.tableMaxRows) {
                  this.hideElement(document.querySelector('.js-arb-explorer-button'));
                }
                queryTask.execute(deadQuery).then(results => {
                  this.deadPlants = results.features;
                  this.getPlantStats();
                });
              }
              if (this.collectionName) {
                const collectionSubtitle = document.querySelector('.topper__subtitle');
                collectionSubtitle.insertAdjacentHTML('afterbegin', ` ${this.livingPlants.length}`);
              }
            } else {
              this.hideArbExplorer();
            }
          })
          .catch(error => {
            this.hideArbExplorer();
            console.error('Error received from ArbExplorer: ', error);
          });
      },
    );
  }

  drawMap() {
    loadModules(
      [
        'esri/Map',
        'esri/views/MapView',
        'esri/layers/GraphicsLayer',
        'esri/layers/VectorTileLayer',
        'esri/geometry/Multipoint',
      ],
      this.mapOptions,
    ).then(([Map, MapView, GraphicsLayer, VectorTileLayer, Multipoint]) => {
      /**
       * CREATE MAP
       */
      // consuming the styled arboretum map that lives on ArcGis
      const vectorLayer = new VectorTileLayer({ url: this.vectorLayerUrl });
      // adding plant features/pointers to map
      const remainingPlants = this.livingPlants.slice(this.tableMaxRows, this.livingPlants.length);
      const remainingPlantsLayer = new GraphicsLayer({ graphics: remainingPlants });
      const displayedPlantsLayer = new GraphicsLayer({ graphics: this.displayedPlants });
      const map = new Map({ layers: [vectorLayer, remainingPlantsLayer, displayedPlantsLayer] });
      const mapViewProperties = {
        container: 'js-specimen-map',
        map: map,
        navigation: {
          mouseWheelZoomEnabled: false,
        },
      };

      // center map on singular result
      if (this.livingPlants.length === 1) {
        mapViewProperties.center = this.livingPlants[0].geometry.toJSON();
        mapViewProperties.scale = 8000;
      } else if (this.livingPlants.length > 1) {
        const points = new Multipoint({
          spatialReference: this.results.spatialReference,
        });
        this.livingPlants.forEach(plant => {
          points.addPoint(plant.geometry);
        });
        // center map on all results
        mapViewProperties.extent = points.extent.expand(1.1).toJSON();
      }

      const view = new MapView(mapViewProperties);
      let selectedPlant = null;

      /**
       * HELPER FUNCTIONS
       */
      // helper function to update point symbols on the map
      const resetSymbol = plant => {
        const geometry = plant.geometry;
        plant.geometry = null;
        plant.geometry = geometry;
      };

      // helper function to style map symbols based on whether the plant is selected(hovered) or not
      const styleSymbol = (plant, selected) => {
        plant.symbol.color = selected ? this.futureGreen : 'white';
        plant.symbol.outline.color = selected ? 'white' : this.timelessGreen;
      };

      // helper function to return the row class name from a given plant
      const selectorFromPlant = plant => plant.attributes['ACC_NUM_AND_QUAL'].replace('*', '_');

      // helper function to return the plant associated with a table row
      const updateSymbolOnRowHover = (element, event, selected) => {
        element.addEventListener(event, () => {
          const plantId = element.classList[0].replace('js-plant-row-', '').replace('_', '*');
          const selectedPlant = this.displayedPlants.find(
            plant => plant.attributes['ACC_NUM_AND_QUAL'] === plantId,
          );
          styleSymbol(selectedPlant, selected);
          resetSymbol(selectedPlant);
        });
      };

      const clearSelected = () => {
        const selector = selectorFromPlant(selectedPlant);
        const row = document.querySelector(`.js-plant-row-${selector}`);
        row.classList.remove('arb-explorer__highlight');
        styleSymbol(selectedPlant, false);
        resetSymbol(selectedPlant);
        selectedPlant = null;
      };

      /**
       * HANDLE MOUSEOVER EVENTS
       */
      // on point hover highlight the plant on the map and in the table
      view.on('pointer-move', event => {
        view.hitTest(event).then(response => {
          if (response.results.length) {
            const hitTestResult = response.results.filter(
              result => this.displayedPlants.indexOf(result.graphic) > -1,
            );
            if (hitTestResult && hitTestResult.length) {
              // edgecase: two pointers adjacent to eachother
              if (selectedPlant) {
                clearSelected();
              }
              selectedPlant = hitTestResult[0].graphic;
              styleSymbol(selectedPlant, true);
              const selector = selectorFromPlant(selectedPlant);
              const row = document.querySelector(`.js-plant-row-${selector}`);
              row.classList.add('arb-explorer__highlight');
              resetSymbol(selectedPlant);
            } else if (selectedPlant) {
              clearSelected();
            }
          }
        });
      });

      // after the map has been built, on table hover highlight the plant on the map
      view.when(() => {
        for (let i = 0; i < this.tableRows.length; i += 1) {
          updateSymbolOnRowHover(this.tableRows[i], 'mouseenter', true);
          updateSymbolOnRowHover(this.tableRows[i], 'mouseleave', false);
        }
      });
    });
  }
}

export default ArbExplorer;
